import styles from './InnerFooter.module.css'
import React, { useMemo, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Slider } from 'antd'
import { FormBuilderContext } from '../../../store/store.FormBuilder'

const InnerFooter = observer(() => {
  const storeFormBuilder = useContext(FormBuilderContext)
  return (
    <div className={styles.innerFooter}>
      <Slider
        className={styles.slider}
        min={10}
        max={500}
        value={storeFormBuilder.zoom}
        onChange={(value) => storeFormBuilder.handleChangeZoom(value)}
      />
    </div>
  )
})

export default InnerFooter
